<template>
  <div class="log-query">
    <Modal title="搜索条件" v-model="searchConditionModal" width="600">
      <Form label-position="top">
        <FormItem label="条件">
          <CheckboxGroup v-model="condition" @on-change="conditionChange">
            <Checkbox label="日志内容"></Checkbox>
            <Checkbox label="日志路径"></Checkbox>
            <Checkbox label="日志分类"></Checkbox>
            <Checkbox label="日志主机"></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem :label="key" v-for="(data, key, idx) in conditionObjects" :key="idx">
          <Input v-if="key === '日志内容'" v-model="data.value" placeholder="请输入关键词" style="width: 560px">
            <Select v-model="data.rule" slot="prepend" style="width: 60px" placeholder="匹配规则">
              <Option value="contain">{{ key === '日志内容' ? '包含' : '等于' }}</Option>
              <Option value="no_equal">{{ key === '日志内容' ? '不包含' : '不等于' }}</Option>
            </Select>
          </Input>
          <Select v-if="key !== '日志内容'" v-model="data.rule" style="width: 80px">
            <Option value="contain">{{ key === '日志内容' ? '包含' : '等于' }}</Option>
            <Option value="no_equal">{{ key === '日志内容' ? '不包含' : '不等于' }}</Option>
          </Select>
          <Select v-if="key === '日志路径'" v-model="data.value" style="width: 480px" filterable>
            <Option v-for="item in logPathList" :value="item" :key="item">{{ item }}</Option>
          </Select>
           <Select v-if="key === '日志分类'" v-model="data.value" style="width: 480px" filterable>
            <Option v-for="item in logCategoryList" :value="item" :key="item">{{ item }}</Option>
          </Select>
           <Select v-if="key === '日志主机'" v-model="data.value" style="width: 480px" filterable>
            <Option v-for="item in logHosts" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button style="float: left" @click="searchConditionClear">清空</Button>
        <Poptip placement="top" width="200">
          <Button type="text" style="color: #2d8cf0">另存为</Button>
          <div class="api" slot="content">
            <div style="padding-bottom: 5px">保存收藏条件：</div>
            <Input v-model="containName" size="small" placeholder="请填写名称"/>
            <div style="float: right; margin-top:5px;">
              <Button type="primary" @click="conditionSave" size="small">保存</Button>
            </div>
          </div>
        </Poptip>
        <Button type="text" style="color: #2d8cf0" @click="conditionSave" :disabled="this.containName ? false : true">保存</Button>
        <Button type="primary" style="margin-left:5px;"  @click="search">查询</Button>
      </div>
    </Modal>
     <Modal title="显示列" v-model="tableColModal">
      <Checkbox-group v-model="col">
        <Checkbox :label="item.field" v-for="item in tableColumnList" :key="item.field" v-if="item.field">{{ item.title }}</Checkbox>
      </Checkbox-group>
      <div slot="footer">
        <Button type="primary" :loading="saveShowColConfiging" style="margin-right: 8px" icon="md-checkmark" @click="saveShowColConfig">确认</Button>
        <Button @click="tableColModal = false">取消</Button>
      </div>
    </Modal>
    <Card style="margin-bottom:10px;">
     <Form ref="searchForm" inline :model="searchForm" :rules="ruleValidSearch">
      <Row>
          <FormItem label="时间" prop="logDate" :label-width="58" class="mob-w-100">
            <DatePicker type="datetimerange" :disabled="dateDisabled" placeholder="Select date and time" style="min-width: 330px" format="yyyy-MM-dd HH:mm:ss" v-model="searchForm.logDate"></DatePicker>
          </FormItem>
           <form-item>
              <radio-group v-model="searchForm.selectTime" type="button"  @on-change="lastTimeChange">
                <radio label="">无</radio>
                <radio label="1">1分钟</radio>
                <radio label="5">5分钟</radio>
                <radio label="10">10分钟</radio>
                <radio label="20">20分钟</radio>
                <radio label="30">30分钟</radio>
                <radio label="60">60分钟</radio>
              </radio-group>
          </form-item>
          <Tooltip content="自动刷新" placement="bottom">
            <i-switch v-model="monitorModal" style="margin-top: 5px" size="large" @on-change="controlMonitorTimer">
              <span slot="open">自动</span>
              <span slot="close">关闭</span>
            </i-switch>
          </Tooltip>
          <FormItem label="显示条数" prop="size" :label-width="70" style="margin-left: 10px;">
            <InputNumber :max="20000" :min="1" v-model="searchForm.size" class="mob-w-100"></InputNumber>
          </FormItem>
          <FormItem label="" prop="key" :label-width="0">
            <Select v-model="currentSearchCondition" placeholder="请选择搜索条件" style="width: 218px" class="mob-w-100" @on-change="searchChange">
              <Option v-for="(item, idx) in searchConditions" :value="item.name" :key="idx">{{ item.name }}</Option>
              <Option value="add-option" style="color: #2d8cf0"><Icon type="ios-add-circle-outline" /> 添加筛选</Option>
            </Select>
            <Tooltip content="筛选" placement="bottom" style="margin-left:5px;">
              <Button icon="ios-funnel" @click="searchConditionModifyOpen"></Button>
            </Tooltip>
            <Tooltip content="显示列" placement="bottom" style="margin-left:5px;">
              <Button icon="ios-settings" @click="showColConfig"></Button>
            </Tooltip>
          </FormItem>
         </Row>
          <Row>
             <Tag v-for="(data, key, idx) in conditionObjects" :key="idx" :name="key" closable @on-close="handleClose" @click.native="tagClick">{{ data.rule === 'no_equal' ? '非 ' : '' }}{{ key }}: {{ data.value }}</Tag>
             <Button icon="ios-add" type="info" size="small" @click="handleAdd">添加筛选</Button>
             <Button type="primary" style="margin-left:5px;" size="small" @click="search">查询</Button>
         </Row>
         <br>
       <Row>
       </Row>
     </Form>
     <Row>
        <!-- <Table
          ref="table"
          size="large"
          :columns="columns"
          :data="tableData"
          :loading="table_loading"
        ></Table> -->
      <!-- <vxe-grid
          border
          resizable
          :show-overflow='searchForm.size > 20 ? true : false'
          :scroll-y="{gt: 20}"
          ref="xGrid"
          height="720"
          :loading="table_loading"
          :data="tableData"
          :columns="columns">
        </vxe-grid> -->
       <vxe-grid
          border
          resizable
          show-overflow
          highlight-hover-row
          highlight-current-row
          ref="xGrid"
          height="720"
          :loading="table_loading"
          :columns="columns">
          <!-- <vxe-table-column field="message" title="message"></vxe-table-column> -->
        </vxe-grid>
      </Row>
      <Drawer
        title="添加索引"
        v-model="change"
        width="730"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <FormItem label="索引名称" prop="indexName">
            <i-input v-model="formItem.indexName" placeholder="请输入索引名称" style="width: 200px;"></i-input>
          </FormItem>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
    <!-- <Card :bordered="false">
      <Row style="margin: 1px;">
        <div style="float: center;background:#eee;padding: 2px;min-height:600px">
          <span v-html="logContent"/>
       </div>
     </Row>
    </Card> -->
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { queryLogs, createIndex, deleteIndex, queryHosts, getHistoryConditions, saveConditon, queryLogCategorys, queryLogPaths } from '@/api/log'
import { getOpsCenterAllServer } from '@/api/opscenter'
import { getModuleAllListLog } from '@/api/workflow/project'
import moment from 'moment'
import ServerTree from '@/view/components/server/server-tree'
import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import VXETablePluginIView from 'vxe-table-plugin-iview'
import 'vxe-table/lib/index.css'
import 'vxe-table-plugin-iview/dist/style.css'

Vue.use(VXETable)
VXETable.use(VXETablePluginIView)

export default {
  name: 'LogQuery',
  components: {
    ServerTree
  },
  data () {
    return {
      showDetails: false,
      selectRow: null,
      logPathList: [],
      logCategoryList: [],
      logHosts: [],
      count: [0, 1, 2],
      dateDisabled: false,
      // col: ['message', 'host.name', 'log.file.path'],
      col: ['message'],
      saveShowColConfiging: false,
      tableColModal: false,
      timer: null,
      monitorModal: false,
      moduleList: [],
      changeLoadingShow: false,
      change: false,
      logContent: '',
      indexList: [],
      hostList: [],
      searchForm: {
        host: [],
        module: '',
        logDate: null,
        size: 100,
        key: null,
        category: this.$store.state.user.defaultTenant,
        selectTime: ''
      },
      formItem: {
        indexName: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidSearch: {
        host: [{ required: true, type: 'string', message: '主机名不能为空 !', trigger: 'change' }],
        module: [{ required: true, type: 'string', message: '日志路径不能为空 !', trigger: 'blur' }],
        logDate: [{ required: true, type: 'array', message: '请选择查询时间', trigger: 'change' }],
        size: [{ required: true, type: 'number', message: '显示条数不能为空 !', trigger: 'blur' }]
      },
      ruleValidate: {
        // host: [{ required: true, message: '主机名不能为空 !', trigger: 'change' }],
        // logDate: [{ required: true, type: 'date', message: '请选择查询时间', trigger: 'change' }]
      },
      // tableColumnList: {
      //   message: {
      //     minWidth: 700,
      //     title: '日志内容',
      //     align: 'left',
      //     key: 'message'
      //   },
      //   timestamp: {
      //     minWidth: 50,
      //     title: '时间',
      //     align: 'left',
      //     key: 'timestamp',
      //     render: (h, params) => {
      //       if (params.row['@timestamp']) {
      //         return h('div', moment(params.row['@timestamp']).format('YYYY-MM-DD HH:mm:ss'))
      //       } else {
      //         return ''
      //       }
      //     }
      //   },
      //   host: {
      //     minWidth: 40,
      //     title: '主机',
      //     align: 'left',
      //     key: 'host',
      //     render: (h, params) => {
      //       if ('name' in params.row.host) {
      //         return h('div', params.row.host.name)
      //       } else {
      //         return ''
      //       }
      //     }
      //   },
      //   path: {
      //     minWidth: 30,
      //     title: '路径',
      //     align: 'left',
      //     key: 'path',
      //     render: (h, params) => {
      //       if ('path' in params.row.log.file) {
      //         return h('div', params.row.log.file.path)
      //       } else {
      //         return ''
      //       }
      //     }
      //   }
      // },
      columns: [],
      tableColumns: [],
      tableColumnList: {
        message: {
          field: 'message',
          title: '日志内容',
          minWidth: 750,
          slots: {
            default: ({ row }, h) => {
              return [
                h('span', {
                  on: {
                    click: () => this.handleRender(row.message)
                  }
                }, row.message)
              ]
            }
          }
        },
        '@timestamp': {
          field: '@timestamp',
          title: '时间',
          minWidth: 50,
          formatter: this.formatTime
        },
        'host.name': { field: 'host.name', title: '主机', minWidth: 20 },
        'log.file.path': { field: 'log.file.path', title: '路径', minWidth: 30 }
      },
      // tableData: [],
      table_loading: false,
      searchConditionModal: false,
      currentSearchCondition: '',
      searchConditions: [],
      condition: [],
      conditionObjects: {},
      containName: '',
      conditionValue: []
    }
  },
  // watch: {
  //   conditionObjects () {
  //     console.log('conditionObjects change')
  //   },
  //   deep: true
  // },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  created () {
    // 动态定义，阻断 vue 对大数据双向绑定，提升加载速度
    this.tableData = []
    clearInterval(this.timer)
    this.timer = null
    this.getShowCol()
    this.getHistoryConditions()
    // this.init()
  },
  mounted () {
    console.log(this.searchConditions)
    this.initData()
    this.conditionSearch()
  },
  methods: {
    init () {
    },
    handleRender (msg) {
      console.log(msg)
      this.$Modal.info({
        width: '1000px',
        title: '日志内容',
        okText: '关闭',
        render: (h) => {
          return h('div', [
            h('pre', {
              props: {
                autosize: { minRows: 6, maxRows: 20 }
              },
              style: {
                'white-space': 'pre-wrap',
                'overflow': 'auto',
                height: '450px'
              }
            }, msg)
          ])
        }
      })
    },
    formatTime ({ cellValue, row, column }) {
      return moment(cellValue).format('YYYY-MM-DD HH:mm:ss')
    },
    tagClick () {
      this.searchConditionModifyOpen()
    },
    handleAdd () {
      this.searchConditionModifyOpen()
    },
    handleClose (event, name) {
      console.log(name)
      // delete this.conditionObjects[name]
      // Vue.delete 可以触发视图更新, delete不会
      Vue.delete(this.conditionObjects, name)
      // 同时要删掉checkBox 勾选状态
      this.condition = Object.keys(this.conditionObjects)
      this.conditionSearch()
    },
    saveConditon () {
      let data = {
        name: this.containName,
        condition: this.conditionObjects
      }
      saveConditon(data).then(res => {
        // 从数据库查询下条件重新赋值，避免另存为和之前的记录界面冲突
        this.getHistoryConditions()
        this.$Message.success('保存成功')
      })
    },
    getHistoryConditions () {
      let that = this
      this.searchConditions = []
      getHistoryConditions().then(res => {
        let result = res.data
        if (result.length > 0) {
          for (let i in result) {
            let d = {
              name: result[i].name,
              condition: result[i].condition
            }
            that.searchConditions.push(d)
          }
        }
        this.currentSearchCondition = this.containName
      })
    },
    lastTimeChange () {
      if (this.searchForm.selectTime) {
        this.searchForm.logDate = [new Date(new Date().getTime() - parseInt(this.searchForm.selectTime) * 60 * 1000), new Date()]
        this.searchForm.size = 500
        // this.dateDisabled = true
        // this.monitorModal = true
      } else {
        this.searchForm.logDate = [new Date(new Date().getTime() - 24 * 60 * 60 * 1000), new Date()]
        this.searchForm.size = 100
        // this.monitorModal = false
        // this.dateDisabled = false
      }
      this.conditionSearch()
      // this.controlMonitorTimer()
    },
    getShowCol () {
      this.getTableColumns()
    },
    saveShowColConfig () {
      this.saveShowColConfiging = true
      this.getTableColumns()
      this.saveShowColConfiging = false
      this.tableColModal = false
    },
    getTableColumns () {
      let data = []
      this.col.forEach(col => data.push(this.tableColumnList[col]))
      data.sort(function (a, b) {
        return b.minWidth - a.minWidth
      })
      this.columns = data
    },
    showColConfig () {
      this.tableColModal = true
    },
    // 自动刷新
    setTimer () {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.conditionSearch()
        }, 10000)
      }
    },
    // 定时刷新控制器
    controlMonitorTimer () {
      if (this.monitorModal) {
        if (this.searchForm.selectTime === '') {
          this.searchForm.selectTime = '1'
        }
        // this.searchForm = JSON.parse(JSON.stringify(this.searchForm))
        this.setTimer()
      } else {
        // this.searchForm.selectTime = ''
        clearInterval(this.timer)
        this.timer = null
      }
    },
    getModuleAllListLog () {
      this.searchForm['module'] = ''
      getModuleAllListLog({ tenant_id__in: this.$store.state.user.defaultTenant }).then(res => {
        this.moduleList = res.data
      })
    },
    deleteIndex () {
      deleteIndex().then(res => {
      })
    },
    handleDateChange (value) {
    },
    // addIndex () {
    //   this.formItem.userId = null
    //   this.change = true
    // },
    getLogsDetail (name) {
      this.table_loading = true
      this.$refs[name].validate((valid) => {
        if (valid) {
          // let hostStr = this.searchForm['host']
          let beginTime = dayjs(this.searchForm.logDate[0]).format('YYYY-MM-DD HH:mm:ss')
          let endTime = dayjs(this.searchForm.logDate[1]).format('YYYY-MM-DD HH:mm:ss')
          let params = {
            host: this.searchForm.host,
            beginTime: beginTime,
            endTime: endTime,
            size: this.searchForm.size,
            key: this.searchForm.key,
            module: this.searchForm.module,
            category: this.searchForm.category,
            selectTime: this.searchForm.selectTime
          }
          queryLogs(params).then(res => {
            // this.logContent = res.data.data
            this.tableData = res.data.data
            // this.tableData = this.tableData.concat(res.data.data)
            this.$refs.xGrid.loadData(this.tableData)
            this.table_loading = false
          }).catch(res => {
            this.table_loading = false
            if (res.request) {
              this.$Notice.error({
                title: '获取日志列表失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    getLogHosts () {
      this.logHosts = []
      queryHosts().then(res => {
        this.logHosts = res.data.data
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取日志列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getLogCategorys () {
      this.logCategoryList = []
      queryLogCategorys().then(res => {
        this.logCategoryList = res.data.data
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取日志列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getLogPaths () {
      this.logPathList = []
      queryLogPaths().then(res => {
        this.logPathList = res.data.data
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取日志列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    drawerClose () {
      let that = this.formItem
      that.index_name = ''
    },
    searchReset () {
      // this.searchForm.name = null
    },
    // getAllIndex () {
    //   getAllIndex().then(res => {
    //     this.indexList = res.data
    //   })
    // },
    onSelectIndex (value) {
    },
    onSelectCategory (value) {
    },
    initData () {
      this.searchForm.logDate = [new Date(new Date().getTime() - 24 * 60 * 60 * 1000), new Date()]
      // this.getAssetOptions()
      this.getLogHosts()
      this.getLogCategorys()
      this.getLogPaths()
    },
    getAssetOptions () {
      getOpsCenterAllServer().then(res => {
        this.hostList = res.data.map(item => item.hostname)
      })
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          createIndex(params).then(res => {
            if (res.data.code === 200) {
              this.$Message.success('添加成功')
            }
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    },
    searchChange (name) {
      console.log(name)
      console.log(this.searchConditions)
      if (name === 'add-option') {
        this.searchConditionModifyOpen()
        this.currentSearchCondition = ''
        this.conditionObjects = {}
        this.containName = ''
        this.condition = []
      } else {
        // 对搜索界面赋值
        let obj = this.searchConditions.filter(item => item.name === name)[0]['condition']
        this.conditionObjects = obj
        this.condition = Object.keys(this.searchConditions.filter(item => item.name === name)[0]['condition'])
        this.containName = name
        // 触发查询方法
        this.conditionSearch()
      }
    },
    searchConditionClear () {
      this.condition = []
      this.conditionChange([])
    },
    searchConditionModifyOpen () {
      this.searchConditionModal = true
    },
    conditionChange (conditions) {
      let mConditions = JSON.parse(JSON.stringify(conditions))
      let conditionObjects = JSON.parse(JSON.stringify(this.conditionObjects))
      for (let i in conditionObjects) {
        let idx = mConditions.indexOf(i)
        if (idx > -1) {
          mConditions.splice(idx, 1)
        } else {
          delete (this.conditionObjects[i])
        }
      }
      for (let i in mConditions) {
        this.conditionObjects[mConditions[i]] = {
          rule: 'contain',
          value: ''
        }
      }
    },
    search () {
      this.searchConditionModal = false
      this.conditionSearch()
    },
    conditionSearch () {
      // 触发日志查询方法
      let obj = this.conditionObjects
      this.searchForm.host = this.dealValue(obj['日志主机'])
      this.searchForm.key = this.dealValue(obj['日志内容'])
      this.searchForm.module = this.dealValue(obj['日志路径'])
      this.searchForm.category = this.dealValue(obj['日志分类'])
      this.getLogsDetail('searchForm')
    },
    conditionSave () {
      this.saveConditon()
      this.searchConditionModal = false
      // 把当前保存的条件放入选择下拉列表
      let d = {
        name: this.containName,
        condition: this.conditionObjects
      }
      // 如果条件不在列表里面则新增，在列表里面则更新列表中的条件
      if (this.searchConditions.filter(item => item.name === this.containName).length > 0) {
        this.searchConditions.map(item => {
          if (item.name === this.containName) {
            item.condition = this.conditionObjects
          }
        })
      } else {
        this.searchConditions.push(d)
      }
      this.currentSearchCondition = this.containName
      // 触发查询方法
      this.conditionSearch()
    },
    dealValue (item) {
      // contain  equal  no_equal
      if (item) {
        if (item['rule'] === 'contain') {
          return item['value']
        } else if (item['rule'] === 'no_equal') {
          return 'NOT-' + item['value'].toString()
        } else {
        }
      } else {
        return ''
      }
    }
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
<style lang="less">
.mob-d-t{
  .ivu-form-item-content{
    display: table;
    margin-left: 0!important;
    float: right;
  }
}
//log-query
.log-query{
  .vue-treeselect__control{
    width:initial;
    min-width: 330px;
  }
  .vue-treeselect__multi-value-item-container {
      padding-top: 1px;
      height: 30px;
  }
  .vue-treeselect__multi-value-item{
    height: 96%;
  }
  .vue-treeselect__multi-value-item{
    line-height: 1;
  }
  .vue-treeselect--has-value .vue-treeselect__multi-value {
    margin-bottom: 0px;
  }
  .vue-treeselect__control{
    height: 32px;
  }
  .ivu-form-item-content{
    line-height: 30px;
  }
  .vue-treeselect__x-container{
    position: relative;
    right: 8px;
  }
}
</style>
